/**
 * Hook to run JSONCargo test flow (BL or container → full chain).
 * Calls POST /tracking/test-run and returns all step payloads.
 * On success invalidates admin tracking queries so usage stats refresh.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPost } from "@/lib/api-client";
import { ADMIN_TRACKING_KEYS } from "@/hooks/api/use-admin-tracking";
import type {
    TrackingTestRunRequest,
    TrackingTestRunResponse,
} from "@/types/api/tracking";

export function useTrackingTestRun() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (
            body: TrackingTestRunRequest
        ): Promise<TrackingTestRunResponse> => {
            return await apiPost<TrackingTestRunResponse>(
                "/tracking/test-run",
                body
            );
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ADMIN_TRACKING_KEYS.all });
        },
    });
}
